/** @jsxImportSource solid-js */
import { createEffect, type JSX } from "solid-js";
import { createCheckboxInput } from "./checkbox.solid";

interface declineable<T> {
  component: JSX.Element;
  disable: (n: boolean) => void;
  value: () => T;
}

/**
 * Render a form element with "I decline to answer" and "Other" options, with an input to enter more detailed info.
 */
export function createDeclineableOther<T>(
  inner: declineable<T>,
  declineValue: T,
  declineLabel = "I decline to answer",
  initial = false,
) {
  const decline = createCheckboxInput(declineLabel, initial);
  createEffect(() => {
    inner.disable(decline.value());
  });

  return {
    component: (
      <>
        {inner.component}
        {decline.component}
      </>
    ),
    value: () => {
      return decline.value() ? declineValue : inner.value();
    },
  };
}
